(ns rlws.iot-cloud.frontend.ajax-common
  (:require [ajax.core :as ajax]
            [ajax.interceptors :refer
             [map->ResponseFormat]]
            [ajax.json :refer [strip-prefix read-json-native]]
            [ajax.protocols :refer [-body]]
            cljs.reader))

(defn make-safe-json-response-format [read-json]
  "Create a json request format given `read-json` function."
  (fn json-response-format
    ([] (json-response-format {}))
    ([{:keys [prefix keywords? raw]}]
     (map->ResponseFormat
      {:read (fn json-read-response-format [xhrio]
               (let [body (-body xhrio)]
                 (if (zero? (count body))
                   nil
                   (read-json raw
                              keywords?
                              (strip-prefix prefix (-body xhrio))))))
       :description (str "JSON"
                         (if prefix (str " prefix '" prefix "'"))
                         (if keywords? " keywordize"))
       :content-type ["application/json"]}))))

(def safe-json-response-format
  "Returns a JSON response format using the native JSON
   implementation. Options include
   :keywords? Returns the keys as keywords
   :prefix A prefix that needs to be stripped off.  This is to
   combat JSON hijacking.  If you're using JSON with GET request,
   you should think about using this. "
  (make-safe-json-response-format read-json-native))

(def edn-response-format
  {:read (fn [xhrio]
           (let [body (-body xhrio)]
             (cljs.reader/read-string body)))
   :description "EDN - Extensible Data Notation"
   :content-type "application/edn"})

(def png-response-format
  {:content-type "image/png"
   :description "PNG image"
   :read -body
   :type :arraybuffer})

(def detect-response-format
  (ajax/detect-response-format
   {:response-format
    [["application/json" (safe-json-response-format {:keywords? true})]
     ["application/edn" edn-response-format]
     ["text/plain" ajax/text-response-format]
     ["text/html" ajax/text-response-format]
     ["*/*" ajax/raw-response-format]]}))
